<template>
  <VDataGridV2
      :loader="dataLoader"
      :context-menu="AssembliesService.contextMenu"
      sticky
      paginated
      entity-type="assembly"
      @row:dblclick="openAssemblyCard"
  >
    <VDataGridColumnV2
        content-class="comment"
    >
      <template #default="{ row }">
        <CommentsButton entity-type-name="assembly" :entity="row"
                        v-if="$core.currentPartner.isBuyer === true"/>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="id"
        width="85px"
        label="№"
        sortable
        sort-default-value="desc"
        filterable
        filter-send-name="idPattern"
        :filter-props="{ placeholder: '№', clearable: true }"
    >
      <template #default="{ row }">
        <VLink @click="openAssemblyCard(row)">{{ $core.utils.string.formatWithDelimiter(row.id) }}</VLink>
        <VBadge v-if="!row.isOfferBased" class="primary">Прямой</VBadge>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="seller"
        label="Грузоотправитель"
        width="200px"
        content-class="ellipsis"
        filterable
        filter-identity="*"
        filter-type="select"
        filter-send-name="seller"
        :filter-props="{ searchFunction: PartnersService.searchSellers, placeholder: 'Название партнера', clearable: true }"
    >
      <template #default="{ row }">
        <div class="ellipsis" :title="row.seller.name">
          {{ row.seller.name }}
        </div>
        <div class="description ellipsis" :title="row.sellerCompany.name">
          {{ row.sellerCompany.name }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="buyer"
        label="Грузополучатель"
        filterable
        filter-identity="*"
        filter-type="select"
        filter-send-name="buyer"
        :filter-props="{ searchFunction: PartnersService.searchBuyers, placeholder: 'Название партнера', clearable: true }"
        width="200px"
        content-class="ellipsis"
    >
      <template #default="{ row }">
        <div class="ellipsis" :title="row.buyer.name">
          {{ row.buyer.name }}
        </div>
        <div class="description ellipsis" :title="row.buyerCompany.name">
          {{ row.buyerCompany.name }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="deliveryType"
        label="Тип доставки"
        content-align="left"
        width="120px"
    >
      <template #default="{ row }">
        {{ row.deliveryType?.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        label="Темп. режим"
        header-class="nowrap"
        content-class="nowrap"
        content-align="center"
    >
      <template #default="{ row }">
        {{ row.storeTemperatureRangeString }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="shippedState"
        label="Отгружен"
        content-align="center"
        filterable
        filter-type="select"
        :filter-props="{
          options: [
            { id: 1, name: 'Полностью',   isShipped: true,  isShippedEntirely: true  },
            { id: 2, name: 'Частично',    isShipped: true,  isShippedEntirely: false },
            { id: 3, name: 'Не отгружен', isShipped: false, isShippedEntirely: false },
          ],
          clearable: true,
        }"
        filter-identity="isShipped,isShippedEntirely"
        width="115px"
    >
      <template #default="{ row }">
        <template v-if="row.isShipped">
          Да
          <div class="description">
            {{ row.isShippedEntirely ? 'Полностью' : 'Частично' }}
          </div>
        </template>
        <template v-else>
          Нет
        </template>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="transportOrderState"
        label="ЗТК"
        content-align="center"
        content-class="nowrap"
        width="110px"
        filterable
        filter-type="select"
        :filter-props="{
          options: [
            { id: 1, name: 'Создана',    isTransportOrderCreated: true  },
            { id: 2, name: 'Не создана', isTransportOrderCreated: false },
          ],
          clearable: true,
        }"
        filter-identity="isTransportOrderCreated"
    >
      <template #default="{ row }">
        <template v-if="row.isTransportOrderCreated">Создана</template>
        <template v-else>Не создана</template>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="assemblyDate"
        label="Дата готовности"
        header-class="nowrap"
        content-align="center"
        content-class="nowrap"
        sortable
        filterable
        filter-type="date-range"
        filter-send-name="assemblyPeriod"
        :filter-props="{ placeholder: 'Введите диапазон', clearable: true }"
        width="150px"
    >
      <template #default="{ row }">
        {{ $core.utils.date.format(row.assemblyDate) }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="plannedReceiptDate"
      label="Дата получения"
      content-align="center"
      header-class="nowrap">
      <template #default="{ row }">
        <div class="nowrap">
          <template v-if="row.plannedReceiptDate">
            {{ $core.utils.date.format(row.plannedReceiptDate) }}
          </template>
          <template v-else>Не задано</template>
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="isOfferBased"
      label="Прямой"
      content-align="center"
      header-class="nowrap"
      filterable
      filter-type="select"
      filter-identity="isOfferBased"
      width="90px"
      :filter-props="{
        options: [
          { id: 1, name: 'Да',  isOfferBased: false },
          { id: 2, name: 'Нет', isOfferBased: true  },
        ],
        clearable: true,
      }"
      >
      <template #default="{ row }">
        <template v-if="row.isOfferBased === false">Да</template>
        <template v-else>Нет</template>
      </template>
    </VDataGridColumnV2>
  </VDataGridV2>
</template>

<script lang="ts">
import AssembliesService        from '@/domains/Assemblies/AssembliesService';
import Assembly                 from "@/domains/Assemblies/Assembly";
import PartnersService          from '@/domains/Partners/PartnersService';
import DataGridLoader           from '@/lib/components/VDataGridV2/DataGridLoader';

export default defineComponent({
  name: 'AssembliesRegistry',

  setup() {
    return {
      AssembliesService,
      PartnersService,
    };
  },

  data() {
    return {
      dataLoader: new DataGridLoader(AssembliesService.getListPaginated)
          .useExtraParams({ requireCommentsInfo: true }),
    };
  },

  methods: {
    async openAssemblyCard(assembly: Assembly): Promise<void> {
      if (await AssembliesService.showAssemblyCard(assembly)) {
        this.dataLoader.refresh();
      }
    },
  },
});
</script>